import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { MantenedorProveedorService } from 'src/app/services/mantenedor-proveedor/mantenedor-proveedor.service';
import Swal from 'sweetalert2';


export interface DialogData {
    usuario: any
    idProveedor: any
    rutProveedor: any
    dvProveedor: any
    nombreCorto: any
    nombreProveedor: any
    fechaEf: any
    direccion: any
    region: any
    idRegion: any
    idComuna: any
    regiones: any
    comunas: any
    rut: any
    cuotas: any
    categorias: any
    idCuotas: any
    minCuotas: any
    idCategoria: any
    codigoFin: any,
    rol: any,
    visibleConvenio: any
}
declare const Rut: any;
@Component({
    selector: 'edita-proveedor',
    templateUrl: '../../pages/mantenedor-proveedor/edita-proveedor.component.html',
    styleUrls: ['../../pages/mantenedor-proveedor/mantenedor-proveedor.component.css']
})
export class DialogEditaProveedor implements OnInit {
    visibles: any = [{ nombre: 'SÍ', id: true }, { nombre: 'NO', id: false }]

    proveedor: any = {
        idProveedor: this.data.idProveedor,
        rutProveedor: this.data.rutProveedor,
        nombreCorto: this.data.nombreCorto,
        nombreProveedor: this.data.nombreProveedor,
        dvProveedor: this.data.dvProveedor,
        direccion: this.data.direccion,
        idRegion: this.data.idRegion,
        idComuna: this.data.idComuna,
        rut: this.data.rut,
        regiones: this.data.regiones,
        comunas: this.data.comunas,
        //cuotas:this.data.cuotas,
        //categorias:this.data.categorias,
        idCategoria: this.data.idCategoria,
        idCuotas: this.data.idCuotas,
        minCuotas: this.data.minCuotas,
        codigoFin: this.data.codigoFin,
        visibleConvenio: this.data.visibleConvenio
    }

    constructor(public dialogRef: MatDialogRef<DialogEditaProveedor>,
        private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private mantenedorProveedorService: MantenedorProveedorService) { }

    ngOnInit(): void {
        let vm = this

        this.mantenedorProveedorService.traeRegionesEspeciales().then
            (regiones => { regiones = regiones })
        this.mantenedorProveedorService.traeCantidadCuotas().then(cuota => this.data.cuotas = cuota).catch(error => console.log(error))

        this.mantenedorProveedorService.traeCategoriaConvenio().then(response => this.data.categorias = response
        ).catch(error => console.log(error))
        console.log("this.proveedor.visibleConvenio !!!!", this.proveedor.visibleConvenio);

    }

    cargaComunas(region: any) {
        this.proveedor.comunas = []
        this.mantenedorProveedorService.traeComunas(
            region).then(comunas => this.data.comunas = comunas).catch(error => console.log(error))
    }


    onCancelarClick(): void { this.dialogRef.close() }

    onGuardarEdicionClick(form: NgForm) {
       
        const dialogRef = this.dialog.open(ConfirmationDialog,
            {
                data: { message: '¿Esta seguro de guardar la edición de proveedor?', buttonText: { ok: 'Si', cancel: 'No' } }
            })
        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                Swal.fire({
                    allowOutsideClick: false,
                    icon: 'info',
                    text: 'Cargando...'
                });
                Swal.showLoading();
                if(this.proveedor.idRegion && this.proveedor.idRegion==-1){
                    this.proveedor.idComuna=0;
                }
               

                this.mantenedorProveedorService.editarProveedor(this.proveedor).
                    then(
                        () => {

                            this.openAlertDialog('Se editó exitosamente el proveedor.', 'btn-success');
                            form.reset();
                            Swal.close();
                            this.dialogRef.close();
                        }
                    )
                    .catch(error => {
                        console.log(error)
                        Swal.close();
                        this.openAlertDialog('Ha ocurrido un error al editar un proveedor.', 'btn-danger')
                    })
            }
        })
    }
    traeComunas() {
        let vm = this

        this.proveedor.comunas = []

        this.mantenedorProveedorService.traeComunas(this.proveedor.idRegion).then(comunas => this.proveedor.comunas = comunas)
    }
    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}